import AbsComponent from './AbsComponent';
import WinResize from '../WinResize';

/**
 * MainBanner class
 * @category main
 */
class IScrollTab extends AbsComponent{
  constructor(_store={}, _el='', _callBack, _isFull = true){
    super(_store, _el);
    this.listsCon = this.el;
    this.lists = this.listsCon.querySelector(`:scope >div`);
    this.listbtns = this.lists.querySelectorAll('a');
    this.defaultWidth = this.lists.clientWidth;
    this.selectList = null;
    this.iscroll = null;
    this.resetTimer = null;
    this.clickTimer = null;
    this.isScroll = false;
    this.callBack = _callBack;
    this.breakPoint = 960;
    this.isFull = _isFull;
    this.setting();
  }
  setting(){
    this.iscroll = new IScroll(this.el, {
      scrollX: true,
      freeScroll: true
    });
    this.iscroll.on('beforeScrollStart', ()=>{
      clearTimeout(this.resetTimer);
      clearTimeout(this.clickTimer);
    });
    this.iscroll.on('scrollEnd', ()=>{
      this.clickTimer = setTimeout(()=>{this.isScroll = false;}, 100);
      this.resetTimer = setTimeout(()=>{this.resize()}, 1500);
    });
    this.iscroll.on('scrollStart', ()=>{
      this.isScroll  = true;
    });

    for (let btn of this.listbtns) {
      btn.addEventListener('click', (e)=>{
        if(this.isScroll)e.preventDefault();
        if(this.callBack ){
          e.preventDefault();
          this.callBack(e);
          return;
        }
      });
    }
    $(window).on( 'resize', ()=>{
      this.resize();
    });

    if(this.store.id != '' && this.store.id != undefined) {
      this.select = this.store.id;
      this.resize();
    }
  }

  resize(){
    //if(!this.isFull)return;
    if(this.listsCon.clientWidth > this.breakPoint){
      if(!this.isFull)return
      this.btnPercentWidth(true);
    }else {
      if (this.defaultWidth > this.listsCon.clientWidth) {
        this.btnPercentWidth(false);
        let gap = this.listsCon.clientWidth - this.lists.clientWidth;
        let tarX = (gap) / 2 + (this.lists.clientWidth / 2 - this.selectList.offsetLeft - this.selectList.clientWidth / 2)
        // this.lists.style.cssText = `margin-left: ${0}px`;
        if (tarX > 0) tarX = 0;
        if (tarX < gap) tarX = gap;
        this.iscroll.scrollTo(tarX, 0, 500, IScroll.utils.ease.quadratic);
      } else {
        if(!this.isFull)return
        this.btnPercentWidth(true);
      }
    }
  }

  btnPercentWidth(b=true){
    if(b){
      this.lists.classList.add('w100');
      for (let btn of this.listbtns) {
        btn.style.width = 100 / this.listbtns.length + '%';
      }
    }else{
      this.lists.classList.remove('w100');
      for (let btn of this.listbtns) {
        btn.style.width = '';
      }
    }

  }

  set select(id){
    if(this.selectList) this.selectList.classList.remove('is-active');
    this.selectList = this.lists.querySelector(`[data-value='${id}']`);
    if(!this.selectList)return;
    this.selectList.classList.add('is-active');
    this.resize();
  }
}
export default IScrollTab;
